import { gql } from '@apollo/client';

export const IS_SUPPORTED_VERSION = gql`
  query isSupportedVersion($version: String!) {
    isSupportedVersion(version: $version)
  }
`;
